import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PageLayoutOptions {
  content_padding?: 'default' | 'none';
  back_navigation?: 'header' | 'page';
  content_class_name?: string;
}
export interface PageLayoutState extends PageLayoutOptions {
  owner: string;
  locationKey: string;
}

const pageLayout = createSlice({
  name: 'pageLayout',
  initialState: null as PageLayoutState | null,
  reducers: {
    setPageLayout: (_state, action: PayloadAction<PageLayoutState>) => action.payload,
    clearPageLayout: (state, action: PayloadAction<string>) =>
      state?.owner === action.payload ? null : state,
  },
});

export function pageContentClass(layout: PageLayoutState | null, locationKey: string): string {
  const current = layout?.locationKey === locationKey ? layout : null;
  return ['art_content_panel', 'art_card',
    current?.content_padding === 'none' ? 'art_content_panel--flush' : '',
    current?.content_class_name || '',
  ].filter(Boolean).join(' ');
}

export const { setPageLayout, clearPageLayout } = pageLayout.actions;
export default pageLayout.reducer;
